import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { XCircle, Save } from "react-feather";

import { DELETE } from "../../../api/adminApi";

export default function InvestementDeleteModal({
   deleteModal: {
      show,
      master: { id, name },
   },
   setDeleteModal,
   getItems,
}) {
   const [loading, setLoading] = useState(false);

   function onHide() {
      setDeleteModal({ show: false, contragent: null });
   }

   async function deleteMaster() {
      setLoading(true);
      const res = await DELETE("/services/admin/api/master/" + id);
      setLoading(false);
      if (res && res.success === true) {
         getItems();
         onHide();
      }
   }

   return (
      <Modal
         aria-labelledby="contained-modal-title-vcenter"
         centered
         show={show}
         onHide={onHide}
      >
         <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
               <div className="w-90">
                  Вы действительно хотите удалить мастер
                  <h5 className="purple-900">{name}</h5>
               </div>
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <div className="d-flex justify-content-end gap-4">
               <button
                  disabled={loading}
                  type="button"
                  onClick={onHide}
                  className="btn btn-outline-purple d-flex align-items-center"
               >
                  <XCircle size={14} className="mr-2" />
                  Отмена
               </button>

               <button
                  disabled={loading}
                  onClick={deleteMaster}
                  className="btn btn-purple d-flex align-items-center"
               >
                  <Save size={14} className="mr-2" />
                  Да
               </button>
            </div>
         </Modal.Body>
      </Modal>
   );
}
